import { render, staticRenderFns } from "./viewGoals.vue?vue&type=template&id=6d280c47"
import script from "./viewGoals.vue?vue&type=script&lang=js"
export * from "./viewGoals.vue?vue&type=script&lang=js"
import style0 from "./viewGoals.vue?vue&type=style&index=0&id=6d280c47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports